import { render } from "./Index.vue?vue&type=template&id=27e19a6c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=27e19a6c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-27e19a6c"

export default script